import { render, staticRenderFns } from "./ApprovalNodeConfig.vue?vue&type=template&id=56f63bdc&scoped=true&"
import script from "./ApprovalNodeConfig.vue?vue&type=script&lang=js&"
export * from "./ApprovalNodeConfig.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalNodeConfig.vue?vue&type=style&index=0&id=56f63bdc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f63bdc",
  null
  
)

export default component.exports